import React, { Component } from 'react';

import Nav from '../components/Nav/Nav';
import Loader from '../components/Loader/Loader';

// HTTP Request
import axios from 'axios';
import SlideImage from '../components/SlideImage';

import { withNamespaces } from 'react-i18next';

// Components
import PopUp from '../components/PopUp/PopUp';
import Modal from '../components/Modal/Modal';
import Reserve from '../components/Reserve/Reserve';

import { Helmet } from 'react-helmet';

class Rooms extends Component {
  reserveModal = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      suite: [],
      reserve: false,
      loading: false
    };
  }

  componentDidMount() {
    document.querySelector('html').style = 'overflow: hidden';
    document.querySelector('body').style = 'overflow: hidden';

    // lang by default
    if (
      this.props.match.params.lang === 'es' ||
      this.props.match.params.lang === 'en'
    ) {
      this.props.i18n.changeLanguage(this.props.match.params.lang);
    } else {
      this.props.history.push('/home/es');
      return console.log('Lang Not Available');
    }

    const api =
      'https://www.hotelnclapaz.com/restapi/public/api';
    // Pass Content By Lang
    if (this.props.match.params.lang === 'en') {
      // get rooms
      axios
        .get(`${api}/webroom`)
        .then(response => {
          const res = response.data.result.data.find(
            item =>
              item.name[this.props.match.params.lang] ===
              this.props.match.params.roomName
          );
          const content = res.content.en;
          const suite = Object.keys(res.webroomimage).map(function(key) {
            return res.webroomimage[key];
          });
          // Before passit to state extract what I need :)
      console.log('room print es', suite, content, res);
          this.setState({ suite, content, res });
        })
        .catch(error => {
          console.log(error);
        });
    }
    if (this.props.match.params.lang === 'es') {
      // get rooms
      axios
        .get(`${api}/webroom`)
        .then(response => {
          const res = response.data.result.data.find(
            item =>
              item.name[this.props.match.params.lang] ===
              this.props.match.params.roomName
          );
          const content = res.content.es;
          const suite = Object.keys(res.webroomimage).map(function(key) {
            return res.webroomimage[key];
          });
          // Before passit to state extract what I need :)
          console.log('room print es', suite, content, res);
          this.setState({ suite, content, res });
        })
        .catch(error => {
          console.log(error);
        });
    }

    setTimeout(() => {
      this.setState({ loading: false });
    }, 2000);
  }

  render() {
    const url = window.location.href;

    if (!this.state.suite.length > 0) {
      return <div />;
    }

    if (this.state.loading) {
      return <Loader loading={this.state.loading} />;
    }

    return (
      <React.Fragment>
        <style jsx>
          {`
            html,
            body {
              overflow: hidden;
              position: relative;
            }
          `}
        </style>
        <Helmet>
          <title>
            {this.props.match.params.roomName} | Hotel NC La Paz
          </title>

          {/* SEO tags */}
          <meta
            property="og:title"
            content={`${
              this.props.match.params.roomName
            } | Hotel NC La Paz`}
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={url} />
          <meta
            property="og:image"
            content={`https://www.hotelnclapaz.com/restapi/public${
              this.state.suite[0].image
            }`}
          />
          <meta
            property="og:description"
            content="Hotel NC ubicado en el centro La Paz - Bolivia, con un estilo moderno, brinda estadía tranquila y placentera. Habitaciones Standard y Suite, desayuno buffet, restaurante, business center, garaje."
          />
          <meta
            property="og:site_name"
            content={`${
              this.props.match.params.roomName
            } | Hotel NC La Paz`}
          />
          <meta
            itemprop="name"
            content={`${
              this.props.match.params.roomName
            } | Hotel NC La Paz`}
          />
          <meta
            itemprop="description"
            content="Hotel NC ubicado en el centro La Paz - Bolivia, con un estilo moderno, brinda estadía tranquila y placentera. Habitaciones Standard y Suite, desayuno buffet, restaurante, business center, garaje."
          />
          <meta
            itemprop="image"
            content={`https://www.hotelnclapaz.com/restapi/public${
              this.state.suite[0].image
            }`}
          />
        </Helmet>

        <Nav
          match={this.props.match.params.lang}
          history={this.props.history}
        />

        <section className="body">
        
          <Modal
            offer={this.state.res.weboffer}
            match={this.props.match.params.lang}
          />
          <PopUp
            reserveModal={this.reserveModal}
            content={this.state.content}
            title={this.props.match.params.roomName}
            button={true}
          />
          <Reserve
            price={this.state.res.price}
            reserve={this.state.reserve}
            email = 'reservas@hotelnclapaz.com'
            reserveModal={this.reserveModal}
            suite={this.state.res}
            match={this.props.match.params.lang}
          />
          <SlideImage data={this.state.suite} />
        </section>
      </React.Fragment>
    );
  }
}

export default withNamespaces('translation')(Rooms);
